import { render, staticRenderFns } from "./Tablist.vue?vue&type=template&id=880e7b6e&scoped=true&"
import script from "./Tablist.vue?vue&type=script&lang=js&"
export * from "./Tablist.vue?vue&type=script&lang=js&"
import style0 from "./Tablist.vue?vue&type=style&index=0&id=880e7b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880e7b6e",
  null
  
)

export default component.exports